<!-- 发票管理 -->

<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
      <!-- 首页列表  begin   -->
      <!-- 首页列表  begin   -->
      <!-- 首页列表  begin   -->
      <!-- 首页列表  begin   -->
      <div v-if="!showDetails">
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item>
            <el-select v-model="query.invoice_type" clearable placeholder="发票类型">
              <el-option label="普通发票" value="1"></el-option>
              <el-option label="专用发票" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-select v-model="query.status" clearable placeholder="发票申请状态">
              <el-option label="开票中" value="5"></el-option>
              <el-option label="已开票" value="1"></el-option>
              <el-option label="已驳回" value="2"></el-option>
              <el-option label="已退票" value="3"></el-option>
              <el-option label="重开待审核" value="4"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-input type="primary" v-model="query.key" placeholder="请输入订单号 / 发票抬头"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="search()">查询</el-button>
            <el-button type="warning" icon="el-icon-download" @click="download()">导出</el-button>
          </el-form-item>
        </el-form>

        <div class="backborder2" style="margin-top:10px">
          <el-table :data="lists" v-loading="listLoading">
            <el-table-column prop="id" align="center" label="开票ID" width="80"></el-table-column>
            <el-table-column prop="documents" align="center" label="订单号" width="150">
              <template slot-scope="scope">
                <div v-for="item in scope.row.documents">{{ item }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="开票金额"></el-table-column>
            <el-table-column prop="customer_name" label="客户名称"></el-table-column>
            <el-table-column align="center" label="抬头类型">
              <template slot-scope="scope">
                {{ scope.row.head_invoice_type == 1 ? '个人' : '单位' }}
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="发票抬头"></el-table-column>
            <el-table-column align="center" prop="tax_number" label="纳税人识别号"></el-table-column>
            <el-table-column align="center" label="发票类型">
              <template slot-scope="scope">
                {{ scope.row.invoice_type == 1 ? '普通发票' : '专用发票' }}
              </template>
            </el-table-column>
            <el-table-column prop="email" align="center" label="收票邮箱"></el-table-column>
            <el-table-column prop="clerk_name" align="center" label="申请人"></el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 0 && scope.row.selll_order_invoice_id > 0">重开待审核</div>
                <div v-if="scope.row.status == 0 && scope.row.selll_order_invoice_id == 0">开票中</div>
                <div v-if="scope.row.status == 1">已开票</div>
                <div v-if="scope.row.status == 2">已驳回</div>
                <div v-if="scope.row.status == 3">已退票</div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" align="center" label="申请时间"></el-table-column>
            <el-table-column prop="audit_time" align="center" label="审核时间"></el-table-column>
            <el-table-column align="center" label="备注" min-width="150">
              <template slot-scope="scope">
                <el-tooltip 
                  effect="dark" 
                  :content="scope.row.content" 
                  placement="top" 
                  :disabled="!scope.row.content || scope.row.content.length <= 20">
                  <span>
                    {{ scope.row.content && scope.row.content.length > 20 ? scope.row.content.substring(0, 20) + '...' : scope.row.content }}
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button :type="scope.row.status == 0 ? 'primary' : 'default'" size="mini" @click="toExamine(scope.row)">{{scope.row.status == 0 ? '审核' : '查看'}}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <!--分页begin-->
            <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="query.p"
              :page-sizes="[10, 20, 50]" :page-size="query.rollpage" layout="total, sizes, prev, pager, next, jumper"
              :total="total_rows">
            </el-pagination>
            <!--分页end-->
          </div>
        </div>
      </div>
      <!-- 首页列表  end   -->
      <!-- 首页列表  end   -->
      <!-- 首页列表  end   -->
      <!-- 首页列表  end   -->


      <!-- 发票详情 -->
      <managementOfInvoicesDetails ref="managementOfInvoicesDetailsRef" v-if="showDetails" @goBack="handleGoBack" />



    </div>
  </transition>
</template>

<script>
import managementOfInvoicesDetails from './managementOfInvoicesDetails.vue';
export default {
  components: {
    managementOfInvoicesDetails
  },
  data() {
    return {
      actionauth: '', //操作权限
      transitionshow: true,
      url: this.GLOBAL.domain + "Invoice/index",
      query: {
        token: this.$cookies.get('token'),
        key: '',
        status: '',
        invoice_type: '',
        p: 1,
        rollpage: 10,
      },
      lists: [],
      listLoading: false,
      customerLoading: false,
      total_rows: 0,
      showDetails: false,
    }
  },
  mounted() {
    this.getList();
  },

  methods: {
    download() {
      // 1. 克隆查询对象，避免直接修改 this.query 导致页面状态变化
      let params = JSON.parse(JSON.stringify(this.query));
      
      // 2. 添加导出专用参数
      params.excel = 1;

      // 3. 构建 Query String
      let queryArr = [];
      for (let key in params) {
        // 确保值存在，避免传递 undefined
        if (params[key] !== null && params[key] !== undefined) {
          queryArr.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
        }
      }
      
      // 4. 拼接完整 URL
      // this.url 已经在 data 中定义为 this.GLOBAL.domain + "Invoice/index"
      const downloadUrl = `${this.url}?${queryArr.join('&')}`;

      // 5. 创建隐藏的 A 标签并触发点击
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = downloadUrl;
      // 设置 target='_blank' 防止万一后端报错直接覆盖当前页面内容，
      // 如果是纯下载流，通常不需要 blank，但加上比较保险
      link.target = '_blank'; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    search() {
      this.query.p = 1;
      this.getList();
    },
    handleGoBack() {
      this.showDetails = false
      this.getList()
    },
    toExamine(row) {
      this.currentItem = row
      this.showDetails = true
      this.$nextTick(() => {
        this.$refs.managementOfInvoicesDetailsRef.getInfo(row.id)
      });
      // console.log(this.$refs.managementOfInvoicesDetailsRef)
      // this.$refs.managementOfInvoicesDetailsRef.getInfo(row.id)
    },
    /** 获取操作权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },



    /** 获取入库信息列表 **/
    getList() {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        this.listLoading = false;
      } else {
        var result = JSON.parse(Base64.decode(res.data.Data));
          this.lists = result;
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
        this.listLoading = false;
      });
    },
    pageSizeChange(val) {
      this.query.rollpage = val;
      this.query.p = 1;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },


  }
}
</script>
<style>
.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 0 1% 3% 1%
}
</style>


// WEBPACK FOOTER //
// src/components/stat/managementOfInvoices.vue